import {useSelector} from "react-redux";
import {RootState} from "../../../../store";
import Header from "../../../navigation/Header";
import {useEffect, useState} from "react";
import {wsapi} from "../../../api/wsapi";
import TherapyForm from "./TherapyForm";
import Interaction from "../interaction/Interaction";
import {DirectionChange, LightPathType, LightShape, TherapyState} from "../therapy-configuration";
import "./HostSession.css";
import {useTranslation} from "react-i18next";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import {VideoCallPanel, useVideoCall, isVideoEnabled} from "../../../../video";
import {useSessionAnalytics} from "../../../../analytics/useSessionAnalytics";

interface HostSessionProps {
    sessionId:string;
}
const HostSession: React.FC<HostSessionProps> = ({sessionId}) => {
    const {t} = useTranslation();
    const [isPreviewHidden, setIsPreviewHidden] = useState<boolean>(false);
    const [isClientJoined, setIsClientJoined] = useState<boolean>(false);
    useSessionAnalytics(isClientJoined);

    const profileData = useSelector((state: RootState) => state.profile);
    const roomId =  'session-' + sessionId;

    // Therapist (host) decides whether video is part of this session. Off by
    // default; the therapist starts it with the button below. Once started the
    // panel stays visible throughout — the therapist observes the client even
    // during BLS sets.
    const videoEnabled = isVideoEnabled();
    const [isVideoOn, setIsVideoOn] = useState<boolean>(false);
    const { state: videoState, localStream, remoteStream } = useVideoCall({
        enabled: videoEnabled,
        isInitiator: true,
        peerPresent: isClientJoined,
        active: isVideoOn,
    });

    const showPreview = () => {
        setIsPreviewHidden(false);
    }
    const hidePreview = () => {
        setIsPreviewHidden(true);
    }
    useEffect(() => {
        wsapi().emit('joinSession', { session: roomId, role: "therapist" });

/*        wsapi().on('message', (message) => {
            console.log('Received message from server:', message);
        });*/
        wsapi().on('clientJoined', (message) => {
            setIsClientJoined(true);
        });
        wsapi().on('clientDisconnected', (message) => {
           setIsClientJoined(false);
        });

//         wsapi().emit('sendMessageToSession', {session: roomId, message: "Hello world"});
//         wsapi().emit('sendEmdrConfiguration', {session: roomId, configuration: "Hello world"});
    }, [])
    return <div>
        {/*HostSession id: {sessionId}*/}

        {isClientJoined ?
        <div className={"client-connected"}>{t("Client has connected")}</div>
            :
        <div className={"client-not-connected"}>{t("Waiting for client to connect")}</div>
        }
        <div className={"session-config-card"}>
            <TherapyForm isClientJoined={isClientJoined} setIsClientJoined={setIsClientJoined}
                previewControl = {
                <>
                    <div className={"preview-panel" + (isPreviewHidden ? " collapsed" : "")}>
                        <div className={"preview-panel-header"}>
                            <span className={"preview-panel-title"}>{t("Preview")}</span>
                            {isPreviewHidden ?
                                <button type="button" className={"preview-toggle"} onClick={showPreview}>
                                    <VisibilityOutlinedIcon fontSize="small" />{t("show preview")}
                                </button>
                                :
                                <button type="button" className={"preview-toggle"} onClick={hidePreview}>
                                    <VisibilityOffOutlinedIcon fontSize="small" />{t("hide preview")}
                                </button>
                            }
                        </div>
                        <div className={"preview-panel-body"} style={{display: isPreviewHidden? "none" : "block"}}>
                            <Interaction additionalClassName = {"preview"} isOppositePersonJoined={isClientJoined} />
                        </div>
                    </div>
                </>
            }/>

        </div>
        {videoEnabled &&
            <section className={"video-card"}>
                <span className={"video-card-icon"} aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                         strokeLinejoin="round">
                        <path d="m23 7-7 5 7 5V7z" />
                        <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
                    </svg>
                </span>
                <div className={"video-card-body"}>
                    <div className={"video-card-title"}>{t("Video call")}</div>
                    <div className={"video-card-sub"}>
                        {isVideoOn
                            ? (videoState === 'connected'
                                ? t("In call")
                                : videoState === 'declined'
                                ? t("Camera/microphone unavailable — continuing without video")
                                : t("Connecting video…"))
                            : t("Share live video with your client during the session")}
                    </div>
                </div>
                <label className={"video-toggle"}>
                    <span className={"video-switch"}>
                        <input
                            type="checkbox"
                            checked={isVideoOn}
                            onChange={() => setIsVideoOn((on) => !on)}
                            aria-label={isVideoOn ? t("End video call") : t("Start video call")}
                        />
                        <span className={"video-switch-slider"} aria-hidden="true" />
                    </span>
                    <span className={"video-toggle-state"}>
                        {isVideoOn ? t("On") : t("Off")}
                    </span>
                </label>
            </section>
        }
        {videoEnabled && isVideoOn &&
            <VideoCallPanel
                variant="therapist"
                state={videoState}
                localStream={localStream}
                remoteStream={remoteStream}
                onClose={() => setIsVideoOn(false)}
            />
        }
    </div>
}
export default HostSession;
